import { AbstractQuery, Query } from "./Query";

export enum CombinatorType
{
  Root,
  Descendant,
  Child,
  NextSibling,
  SubsequentSibling
}

export class CombinatorTypes
{
  static getSelectorSymbol( type:CombinatorType )
  {
    switch ( type )
    {
      case CombinatorType.Root: return "";
      case CombinatorType.Descendant: return " ";
      case CombinatorType.Child: return ">";
      case CombinatorType.NextSibling: return "+";
      case CombinatorType.SubsequentSibling: return "~";
    }

    return null;
  }
}

export class CombinatorEntry
{
  type:CombinatorType;
  query:Query;
}

export class CombinedSelector extends AbstractQuery
{
  protected _entries:CombinatorEntry[] = [];
  protected _cache = true;
  protected _cachedSelector:string = null;

  get selector()
  { 
    if ( this._cache && this._cachedSelector )
    {
      return this._cachedSelector;
    }

    let selectorParts = [];

    for ( let i = 0; i < this._entries.length; i++ )
    {
      selectorParts.push( CombinatorTypes.getSelectorSymbol( this._entries[ i ].type ) );
      selectorParts.push( this._entries[ i ].query.selector );
    }

    let cachedSelector = selectorParts.join( "" );

    if ( this._cache )
    {
      this._cachedSelector = cachedSelector;

      // console.log( "Combined Selector:", this._cachedSelector );
    }
    
    return cachedSelector;
  }

  static create( ...selectors:Query[] )
  { 
    let cs = new CombinedSelector();

    for ( let i = 0; i < selectors.length; i++ )
    {
      let entry = new CombinatorEntry();
      entry.type = i === 0 ? CombinatorType.Root : CombinatorType.Descendant;
      entry.query = selectors[ i ];
      cs._entries.push( entry );
    }

    return cs;

  }
}